// extracted by mini-css-extract-plugin
module.exports = {"hotel":"Hotel_hotel__2Ofes"};